import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { BalanceLookupCooldownDTOBase } from "./BalanceLookupCooldownDTOBase";
import type { BalanceStaff } from "./BalanceStaff";
import type { PersonStaff } from "./PersonStaff";
import type { TrackedBase } from "./TrackedBase";

export class BalanceLookupCooldownStaff implements BalanceLookupCooldownDTOBase, TrackedBase {
  constructor(public readonly assignId: number, public readonly searchAttempt: string, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly personId: PersonStaff | null, public readonly balanceMatch: BalanceStaff | null) {
    this.cbiServiceContext = null;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
    this.balanceMatchLoaded = this.balanceMatch != null;
    this.balanceMatchCached = this.balanceMatch;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  private balanceMatchLoaded: boolean;
  private balanceMatchCached: BalanceStaff | null;
  async personIdLazy(): Promise<PersonStaff> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.balanceService().getBalanceLookupCooldownStaffPersonId(this.assignId);
      this.personIdLoaded = true;
    }
    return this.personIdCached!;
  }
  async balanceMatchLazy(): Promise<BalanceStaff | null> {
    if (!this.balanceMatchLoaded) {
      this.balanceMatchCached = await this.cbiServiceContext!.balanceService().getBalanceLookupCooldownStaffBalanceMatch(this.assignId);
      this.balanceMatchLoaded = true;
    }
    return this.balanceMatchCached;
  }
}
